const userInfoFromRow = [
  {
    span: 20,
    label: '用户名',
    component: 'AInput',
    placeholder: '请输入用户名',
    prop: 'userName',
    allowClear: true,
  },
  {
    span: 20,
    label: '机构',
    component: 'AInput',
    placeholder: '请输入机构名称',
    prop: 'enpName',
    allowClear: true,
    disabled: true,
  },
  {
    span: 20,
    label: '手机号',
    component: 'AInput',
    placeholder: '请输入手机号',
    prop: 'phonenumber',
    allowClear: true,
  },
  {
    span: 20,
    label: '邮箱',
    component: 'AInput',
    placeholder: '请输入邮箱',
    prop: 'email',
    allowClear: true,
    disabled: true,
  },
];

const companyFromRow = [
  {
    span: 20,
    label: '机构地址',
    component: 'AInput',
    placeholder: '请输入机构地址',
    prop: 'enpAddress',
    allowClear: true,
  },
  {
    span: 20,
    label: '联系电话',
    component: 'AInput',
    placeholder: '请输入联系电话',
    prop: 'enpPhone',
    allowClear: true,
  },
  {
    span: 20,
    label: '联系人',
    component: 'AInput',
    placeholder: '请输入联系人',
    prop: 'enpContact',
    allowClear: true,
  },
  {
    span: 20,
    label: '统一社会信用代码(营业执照号码)',
    component: 'AInput',
    placeholder: '请输入统一社会信用代码',
    prop: 'enpNo',
    allowClear: true,
  },
];
var reg = new RegExp(
  '(^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$)|(^(\\(\\d{3,4}\\)||\\d{3,4}-|\\s)?\\d{7,14}$)'
); // 校验手机号和电话
var reg1 = new RegExp(
  '^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\\d{8}$'
); // 校验手机号
const formRules = {
  enpPhone: [
    {
      validator: (rule, val, callback) => {
        if (!reg.test(val)) {
          callback(new Error('请输入正确的联系电话!'));
        } else {
          callback();
        }
      },
    },
  ],
  phonenumber: [
    {
      validator: (rule, val, callback) => {
        if (!reg1.test(val)) {
          callback(new Error('请输入正确的手机号!'));
        } else {
          callback();
        }
      },
    },
  ],
};

module.exports = {
  userInfoFromRow,
  companyFromRow,
  formRules,
};
